<template>
    <div>
        <center>
            <h3>Hapus Duplikat</h3>
        </center>
        <br>
        <form v-on:submit.prevent="validateWhatsapp">
            <div class="alert alert-warning" role="alert">
            Mohon diperhatikan, penghapusan nomor duplikat adalah secara global, mungkin dapat mempengaruhi daftar anggota group
            </div>
            <button class="btn btn-primary btn-block" :disabled="isLoading">
                <span v-if="isLoading">
                    <div class="spinner-border spinner" role="status"></div>
                    Sedang memproses...
                </span>
                <span v-else>
                    Submit
                </span>
            </button>

        </form>
    </div>
</template>

<script>

    export default {
        components: {
        },
        props: ["devices"],
        data() {
            return {
                isLoading: false,
            };
        },
        mounted() {
        },
        methods: {

            async validateWhatsapp() {
                this.isLoading = true
                try {
                    this.$toast.success("Proses penghapusan nomor duplikat sedang berjalan di latar belakang. Silakan tunggu...");
                    let response = await this.$store.dispatch("contact_remove_duplicate");
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                } finally {
                    this.isLoading = false
                    this.$root.$emit("toggle_modal", "hapus_duplikat")
                    this.$root.$emit("refresh_table", true)
                }
            },
        },
    };
</script>

<style scoped>
    .spinner {
        height: 1rem !important;
        width: 1rem !important;
    }

    .btn-spinner {
        line-height: 1rem !important;
    }
</style>

<style scoped>
    .thick-border {
        border: 2px solid #6c6c6c !important;
    }

    .selectAll {
        margin-right: 0.25rem; /* Tailwind: mr-1 */
        border: 1px solid #d1d5db; /* Tailwind: border-gray-300 */
        padding: 0.25rem 0.5rem; /* Tailwind: px-2 py-1 */
        border-radius: 0.375rem; /* Tailwind: rounded-md */
        background-color: white;
        color: #374151; /* Tailwind: text-gray-700 */
        font-size: 0.875rem; /* Tailwind: text-sm */
        transition: background-color 0.2s, color 0.2s; /* Tailwind: transition-colors duration-200 */
    }

    .selectAll:hover {
        background-color: #10b981; /* Tailwind: bg-emerald-500 */
        color: white;
    }
</style>